module.exports = __webpack_public_path__ + "static/media/ivrs.2b5fbf5b.svg";